export default "__VITE_ASSET__dca72760__"